import {
  IconBranchOffices,
  IconCheckouts,
  IconCollegialLending,
  IconCompanies,
  IconDashboard,
  IconDocument1,
  IconFlexPools,
  IconInbox,
  IconJobs,
  IconOperation,
  IconPlanning,
  IconProject,
  IconSetting2,
  IconToday2,
  IconUsers,
} from 'assets/img';
import { paths } from 'ogp/paths';
import { useTranslation } from 'react-i18next';
import { getCheckoutsArchiveDefaultFilters } from '../administration/shared';

export const useSidebarItems = () => {
  const { t } = useTranslation('ogp-screen-specific');

  return [
    {
      key: 'dashboard',
      name: t('sidebar.dashboard'),
      children: [
        {
          ...paths.Dashboard,
          label: t('sidebar.dashboard'),
          icon: <IconDashboard />,
        },
      ],
    },
    {
      key: 'planning',
      name: t('sidebar.planning'),
      children: [
        {
          ...paths.ShiftPlanning,
          label: t('sidebar.shift_planning'),
          icon: <IconPlanning />,
        },
        {
          ...paths.Projects,
          label: t('sidebar.project_planning'),
          icon: <IconProject />,
        },
      ],
    },
    {
      key: 'administration',
      name: t('sidebar.administration'),
      children: [
        {
          ...paths.CheckoutsInbox,
          label: t('sidebar.checkouts_inbox'),
          icon: <IconInbox />,
        },
        {
          ...paths.CheckoutsArchive,
          path: `${paths.CheckoutsArchive.path}${getCheckoutsArchiveDefaultFilters()}`,
          label: t('sidebar.checkouts_archive'),
          icon: <IconCheckouts />,
        },
      ],
    },
    {
      key: 'workforce-management',
      name: t('sidebar.workforce-management.title', { defaultValue: 'Workforce Management' }),
      children: [
        {
          ...paths.Workforce,
          label: t('sidebar.pool-management.label', { defaultValue: 'Pool management' }),
          icon: <IconOperation />,
        },
        {
          ...paths.FlexPools,
          label: t('sidebar.flex_pools'),
          icon: <IconFlexPools />,
        },
        {
          ...paths.Availability,
          label: t('sidebar.availability'),
          icon: <IconToday2 />,
        },
      ],
    },
    {
      key: 'client-management',
      name: t('sidebar.client-management.title', { defaultValue: 'Client Management' }),
      children: [
        {
          ...paths.CollegialLendingCustomers,
          label: t('sidebar.service-account-customers.label', {
            defaultValue: 'Service account for Customers',
          }),
          icon: <IconCollegialLending />,
        },
      ],
    },
    {
      key: 'supplier-management',
      name: t('sidebar.supplier-management.title', { defaultValue: 'Supplier Management' }),
      children: [
        {
          ...paths.CollegialLendingSuppliers,
          label: t('sidebar.service-account-suppliers.label', {
            defaultValue: 'Service account for Suppliers',
          }),
          icon: <IconCollegialLending />,
        },
      ],
    },
    {
      key: 'management',
      name: t('sidebar.management'),
      children: [
        {
          ...paths.Company,
          label: t('sidebar.company'),
          icon: <IconCompanies />,
        },
        {
          ...paths.BranchOffices,
          label: t('sidebar.branch_offices'),
          icon: <IconBranchOffices />,
        },
        {
          ...paths.Departments,
          label: t('sidebar.departments'),
          icon: <IconBranchOffices />,
        },
        {
          ...paths.WorkTemplates,
          label: t('sidebar.work_templates'),
          icon: <IconJobs />,
        },
        {
          ...paths.Users,
          label: t('sidebar.users'),
          icon: <IconUsers />,
        },
        {
          ...paths.Legal,
          label: t('sidebar.legal_documents'),
          icon: <IconDocument1 />,
        },
        {
          ...paths.Workflows,
          label: t('sidebar.workflows'),
          icon: <IconOperation />,
        },
        {
          ...paths.Settings,
          label: t('sidebar.settings'),
          icon: <IconSetting2 />,
        },
      ],
    },
  ] as const;
};
